'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { DangerousInnerHTML } from '@/shared/components/dangerous-inner-html';
import { getUrlToAccountServiceApi } from '@/shared/modules/api';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import { useProfileDataQuery } from '../../hooks/use-profile-data-query';
import { SecurityButtonLink } from '../security-button-link';
import * as Styled from './profile-overview.styled';
export const PrivateProfileOverview = React.memo(function PrivateProfileOverview() {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  const {
    data,
    isLoading
  } = useProfileDataQuery();
  if (!data || isLoading) {
    return null;
  }
  return <Styled.ColumnsWrapper>
      <Styled.Column>
        <Styled.ColumnCard>
          <Styled.ColumnCardTitle>{profileModel.strings.personalInformation}</Styled.ColumnCardTitle>

          <Styled.TextRow {...buildQaTrackingEntityProps('newProfile.info.nickName')}>
            <Styled.ColumnCardLightText>{profileModel.strings.nickName}</Styled.ColumnCardLightText>
            <Styled.ColumnCardDarkText>{data.name}</Styled.ColumnCardDarkText>
          </Styled.TextRow>

          {data.about ? <>
              <Styled.TextRow {...buildQaTrackingEntityProps('newProfile.info.about')}>
                <Styled.ColumnCardLightText>{profileModel.strings.aboutMe}</Styled.ColumnCardLightText>
                <Styled.ColumnCardDarkText>{data.about}</Styled.ColumnCardDarkText>
              </Styled.TextRow>
            </> : null}
        </Styled.ColumnCard>

        <Styled.ColumnCard>
          <Styled.ColumnCardTitle>{profileModel.strings.paymentMethod}</Styled.ColumnCardTitle>

          <Styled.ColumnCardDarkText>{profileModel.strings.currentCountry}</Styled.ColumnCardDarkText>

          <Styled.PaymentMethodPlaceholderDisabled>{data.country}</Styled.PaymentMethodPlaceholderDisabled>

          <Styled.ColumnCardLightText>
            <DangerousInnerHTML html={profileModel.strings.paymentMethodDescription} tagName="span" suppressHydrationWarning />
          </Styled.ColumnCardLightText>
        </Styled.ColumnCard>
      </Styled.Column>

      <Styled.Column>
        {profileModel.repeaters.securityLinks ? <Styled.ColumnCard>
            <Styled.SecurityLinksTextWrapper>
              <Styled.ColumnCardTitle>{profileModel.strings.accountInformation}</Styled.ColumnCardTitle>
              <Styled.ColumnCardLightText>{profileModel.strings.accountInformationDesc}</Styled.ColumnCardLightText>
            </Styled.SecurityLinksTextWrapper>
            <Styled.SecurityLinksList>
              {profileModel.repeaters.securityLinks.map(link => <Styled.SecurityLinksListItem key={link.strings.text}>
                  <SecurityButtonLink id={link.options.id} href={`${getUrlToAccountServiceApi().toString()}${link.links.href}`} text={link.strings.text} />
                </Styled.SecurityLinksListItem>)}
            </Styled.SecurityLinksList>
          </Styled.ColumnCard> : null}
      </Styled.Column>
    </Styled.ColumnsWrapper>;
});